import React from 'react';
import {
    Button, Form, FormGroup, Label,
    Col,
    Container, Row, FormText
} from 'reactstrap';
import DateSelector from "../utils/dateSelector";
import SelectListComponent from "../utils/selectList";

const SearchPanel = ({ onSearch, startDateChange, endDateChange, dateType, selectedDateType, onDateTypeChange, componentErrorMessages}) => {
    return (
        <Form>
            <Container>
                <Row style={{justifyContent: "center"}}>
                    <Col xs="3" >
                        <FormGroup className="mb-4">
                            <Label>Start Date</Label>
                            <DateSelector
                                maxDate={new Date()}
                                todayDate={(new Date()).toString()}
                                name="startDate" onValueChange={startDateChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="3">
                        <FormGroup className="mb-4">
                            <Label>End Date</Label>
                            <DateSelector
                                maxDate={new Date()}
                                todayDate={(new Date()).toString()}
                                name="endDate" onValueChange={endDateChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="3" >
                        <FormGroup className="mb-4">
                            <Label>Date Type</Label>
                            <SelectListComponent
                                data={dateType}
                                valueKey="Id"
                                textField="Name"
                                selectValue={selectedDateType}
                                onValueChange={onDateTypeChange}
                            />
                            {componentErrorMessages.dateType && <FormText color="danger"> {componentErrorMessages.dateType}</FormText>}
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="1">
                        <label>&nbsp;</label>
                        <Button className="btn-avi-primary" onClick={() => onSearch(1)}>
                            Index Manifest
                        </Button>
                    </Col>
                </Row>
            </Container>
        </Form>
    );
};

export default SearchPanel;


// WEBPACK FOOTER //
// ./src/views/elastic-search-sync/search-panel.js